import React, {
  useState,
  useContext,
  // useLayoutEffect,
  // useEffect,
  useMemo,
} from "react";
import { useParams, useLocation } from "react-router-dom";
// import {
//   Map0set,
//   Map1set,
//   Map2set,
//   Syukurendou,
//   Rotate0set,
//   Rotate1set,
//   Rotate2set,
//   Fullviewerset,
// } from "./buttons";
// import {
//   Static2Map0set,
//   Static2Map0aset,
//   Static2Map1set,
//   Static2Map2set,
// } from "./kashikabuttons";
// import { Year0set, Year1set, Year2set } from "./kashikabuttons";
// import { Area0set, Area1set, Area2set } from "./kashikacityset";
import {
  FullviewerSet,
  ModeSet,
  Area1Set,
  Area2Set,
  ShowratioSet,
  ModalcolorSet,
} from "./../../App";
// } from "./App";
import { Static2Map1Set, Static2Map2Set } from "./../../App";
import { Zoomlevel1Set } from "./../../App";
import { Zoomhanrei1Set, Zoomhanrei2Set } from "./../../App";
import { Year1Set, Year2Set } from "./../../App";

// import { Alpha1Set, Alpha2Set } from "./../../App";

import { RendouSet } from "./../../App";
import { SyukurenSet } from "./../../App";
import { SyosaiSet } from "./../../App";
import { StartmodalSet } from "./../../App";
// import data_meta1 from "./geograph/metadatas/meta_data_20260211_g";
import data_meta1 from "./../metadatas/meta_data_20260211_g";
// import meta_mieruka from "./mieruka/meta_mieruka_20260121";
import meta_mieruka from "./../../mieruka/meta_mieruka_20260121.json";
let data_meta = data_meta1.concat(meta_mieruka);

// import Hanrei from "./geograph/HanreiGeograph/hanrei";
// import Hanreikokudo from "./geograph/HanreiGeograph/hanreikokudo";
// import { Hanreikakudai } from "./geograph/HanreiGeograph/hanreikakudai";
import { Modalcity0set } from "./../modals/citysetmodal";
import { Modalratio0set } from "./../modals/ratiosetmodal";
// import { Modalstart } from "./startmodal";
import { Modalstart } from "./../../startmodal";
import { Modalsyosai } from "./../modals/syosaimodal";

// import { MierukaHeader } from "./mieruka/mierukaHeader";
// import { MierukaFooter } from "./mieruka/mierukaFooter";

// import { GeographFooter } from "./geograph/panels/geographFooter";
// import { GeographHeader } from "./geograph/panels/geographHeader";
// import { GeographTab } from "./geograph/panels/geographTab";
// import { GeographTitle } from "./geograph/panels/geographTitle";
// import { GamepadTest } from "./test3dmouse";
// import { ModalColorset } from "./mieruka/modalColorset";
// import { AddCesiumNavigation } from "./coreCesium/addCesiumNavigation";
// import { Cesium1Set } from "./App";
// import { DaiproHeader } from "./daipro/daiproHeader";
// import { DaiproFooter } from "./daipro/daiproFooter";
// import { HanreiGeograph } from "./geograph/HanreiGeograph";

export const GeographModal = (props) => {
  // const { fullviewerset, setFullviewerSet } = useContext(FullviewerSet);
  // const { modeset, setModeSet } = useContext(ModeSet);
  const { startmodalset, setStartmodalSet } = useContext(StartmodalSet);
  // const [showcityset, setShowcityset] = useState(false);
  // const [filecheckset, setFilecheckset] = useState(0);
  const { static2map1set, setStatic2Map1Set } = useContext(Static2Map1Set);
  const { static2map2set, setStatic2Map2Set } = useContext(Static2Map2Set);
  // const { area1set, setArea1Set } = useContext(Area1Set);
  // const { area2set, setArea2Set } = useContext(Area2Set);
  // const { year1set, setYear1Set } = useContext(Year1Set);
  // const { year2set, setYear2Set } = useContext(Year2Set);
  // const { zoomlevel1set, setZoomlevel1Set } = useContext(Zoomlevel1Set);
  // const { zoomhanrei1set, setZoomhanrei1Set } = useContext(Zoomhanrei1Set);
  // const { rendouset, setRendouSet } = useContext(RendouSet);
  // const { syukurenset, setSyukurenSet } = useContext(SyukurenSet);
  const { syosaiset, setSyosaiSet } = useContext(SyosaiSet);
  // const { modalcolorset, setModalcolorSet } = useContext(ModalcolorSet);
  const { showratioset, setShowratioSet } = useContext(ShowratioSet);
  // const { alpha1set, setAlpha1Set } = useContext(Alpha1Set);
  // const { alpha2set, setAlpha2Set } = useContext(Alpha2Set);

  const params = useParams();
  // console.log(params);
  const location = useLocation();
  const locationsetting = decodeURI(location.search).split("_");
  const metatmp = data_meta.filter((r) => {
    return r.no == params.no;
  });
  const meta = useMemo(() => metatmp[0], [metatmp[0]]);

  const metadata = static2map1set;
  const metadata2 = static2map2set;

  return (
    <>
      <div className="absolute z-40">
        {/* <Modalcity0set show={showcityset} setShow={setShowcityset} /> */}
        <Modalcity0set show={props.show} setShow={props.setShow} />
        {props.children}
        <Modalratio0set show={showratioset} setShow={setShowratioSet} />
        <Modalstart show={!startmodalset} setShow={setStartmodalSet} />
        <Modalsyosai
          metadata={metadata}
          metadata2={metadata2}
          show={syosaiset}
          setShow={setSyosaiSet}
        />
      </div>
    </>
  );
};
